
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Shortkey numpad.
 */
Vue.use(require('vue-shortkey'))

/**
 * Element.io
 */
import ElementUI from 'element-ui'
Vue.use(ElementUI)

/**
 * SweetAlert
 */
import VueSweetAlert from 'vue-sweetalert'
Vue.use(VueSweetAlert)
import DatePicker from 'vue-bootstrap-datetimepicker'
Vue.use(DatePicker)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/**
 * Vuefire for firebase.
 */
// const VueFire = require('vuefire')
// window.Firebase = require('firebase')
// Vue.use(VueFire)

/**
 * Vuetable.
 */
const Vuetable = require('vuetable-2')
Vue.use(Vuetable)

// Finding user's language.
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const language = window.Config.LOCALE
const segments = language.split('_')
window.currentLang = _.head(segments)
window.currentLocale = segments.join('-')
// Create VueI18n instance with options
import sysMessages from '../app/messages/system'
import appMessages from '../lotto/messages'

const messages = _.merge(appMessages, sysMessages)

const i18n = new VueI18n({
  locale: currentLang,
  messages
})

/**
 * Import vuex store.
 */
import store from './store'

/**
 * Filter number format.
 */
import numeral from 'numeral'
import Vue from 'vue';
Vue.filter('number', (number, format = '0,0') => {
  number = Math.floor(number)
  return numeral(number).format(format)
})

Vue.filter('positiveInteger', function (value) {
  var number = +value.replace(/[^\d.]/g, '')
  return isNaN(number) ? 0 : parseFloat(number.toFixed())
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/') + (parseInt(moment(String(value)).format('YYYY')) + 543) + moment(String(value)).format(' HH:mm')
  }
})

Vue.filter('fullFormatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/') + (parseInt(moment(String(value)).format('YYYY')) + 543) + moment(String(value)).format(' HH:mm:ss')
  }
})
Vue.filter('float', (number, format = '0,0.00') => {
  const numberFormat = numeral(number).format(format)
  return numberFormat.replace('.00', '')
})
/**
 * Validation config.
*/
const VeeValidate = require('vee-validate')
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: {
    en: {
      messages: {
        required: function () {
          return 'กรุณากรอกตัวเลข 5 หลัก'
        },
        numeric: function () {
          return 'กรุณากรอกตัวเลขเท่านั้น'
        },
        digits: function (digits, number) {
          return 'กรุณากรอกตัวเลชให้ครบ ' + number + ' หลัก'
        },
        between: (value, params) => `กรุณาระบุ ค่าระหว่าง ${params[0]} และ ${params[1]}`
      },
      attributes: {
        ykn: 'ตัวเลข'
      }, custom: {
        amount: {
          required: (value, params) => `กรุณาระบุ จำนวนเงิน`,
          between: (value, params) => `กรุณาระบุ ค่าระหว่าง ${params[0]} และ ${params[1]}`,
          numeric: (value, params) => `กรุณาระบุ เฉพราะตัวเลขเท่านั้น`
        },
        transfer_wallet_to: {
          required: (value, params) => `กรุณาระบุ กระเป๋าเงินปลายทาง`
        },
        transfer_wallet_from: {
          required: (value, params) => `กรุณาระบุ กระเป๋าเงินต้นทาง`
        },
        bank_code: {
          required: (value, params) => `กรุณาระบุ ธนาคาร`
        },
        deposit_amount: {
          required: (value, params) => `กรุณาระบุ จำนวนเงิน`,
          min_value: (value, params) => `กรุณาระบุขั้นต่ำ ${params[0]} ถึงจะสามารถแจ้งฝากได้`
        },
        date: {
          required: (value, params) => `กรุณาระบุ วันที่`,
          date_format: (value, params) => `กรุณาระบุ วันที่ให้ถูกต้อง`
        },
        time: {
          required: (value, params) => `กรุณาระบุ เวลา`,
          date_format: (value, params) => `กรุณาระบุ เวลาให้ถูกต้อง`
        },
      }
    }
  },
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
}
Vue.use(VeeValidate, config)

/**
 * Global components.
 */
Vue.component('top-users', require('./components/TopUsers'))
Vue.component('notification', require('./components/Notification'))
Vue.component('direct-message', require('./components/DirectMessage'))
Vue.component('game-limitation', require('./components/GameLimitation'))
Vue.component('master-agent-share', require('./components/MasterAgentShare'))
Vue.component('member-information', require('./components/MemberInformation'))
Vue.component('member-bet-games', require('./components/MemberBetGames/MemberBetGames'))
Vue.component('member-stakes-sum', require('./components/MemberStakesSum/MemberStakesSum'))
Vue.component('affiliate-members', require('./components/AffiliateMembers/AffiliateMembers'))
Vue.component('member-transactions', require('./components/MemberTransactions/MemberTransactions'))
Vue.component('member-request-deposit-v2', require('./components/MemberRequestDeposit'))
Vue.component('member-request-deposit-vizpay', require('./components/VizPay'))
Vue.component('games-machine-keno', require('./components/games-machine/keno'))
Vue.component('games-machine-control', require('./components/games-machine/control'))
Vue.component('news-list', require('./components/NewsList'))
Vue.component('member-request-transfer', require('./components/MemberRequestTransfer'))
Vue.component('joker-game-list', require('./components/JokerGameList'))
Vue.component('naga-game-list', require('./components/NagaGameList'))
Vue.component('amb-game-list', require('./components/AmbGameList'))
Vue.component('pg-slot-history', require('./components/PgSlotHistory'))
Vue.component('amb-small-game-list', require('./components/AmbSmallGameList'))
/**
 * Baccarat control for dealer
 */
Vue.component('game-table', require('./pages/games/GameTable'))
Vue.component('soccer-score', require('./pages/soccer/Entries'))
Vue.component('dealer-baccarat', require('./pages/dealer/Baccarat'))
Vue.component('wrapper-game-table', require('./pages/games/WrapperGameTable'))
// Vue.component('sport-soccer-pre-match', require('./pages/sports/soccerPreMatch'))
// Vue.component('sport-soccer-in-play', require('./pages/sports/soccerInPlay'))
// Vue.component('sport-soccer-fixture', require('./pages/sports/fixture'))
Vue.component('games-machine', require('./pages/games-machine/app'))


/**
 * Lotto components.
 */
Vue.component('lotto', require('../lotto/pages/Game'))
Vue.component('auto-lotto', require('../autolotto/pages/Game'))
Vue.component('auto-lotto-result', require('../autolotto/pages/Result'))

/**
 * Game predictation by agent.
 */
// Vue.component('predict-games', require('./pages/predict/Games'))

const app = new Vue({
  el: '#app',
  store,
  i18n
});



// WEBPACK FOOTER //
// ./resources/assets/js/admin/index.js